const NO_BINDING_SUFFIXES = ["REGULAR", "KEEP", "keep_existing", "keepExisting", "existing-subscription-placeholder"];

// Binding length isn't a real OM field - inferred from the offering code's Icim suffix naming convention.
export const getBindingPeriodLabel = (offeringCode?: string | null): string | null => {
    if (!offeringCode) return null;
    const suffix = offeringCode.split(".").pop();
    if (!suffix) return null;
    if (NO_BINDING_SUFFIXES.includes(suffix)) return "Ingen binding";
    const months = suffix.match(/\d+/)?.[0];
    return months ? `${months} md. binding` : null;
};

const BINDING_TYPE_LABELS: Record<string, string> = {
    TLF12PLEAS: "telefonbinding",
    COM12LOUDSPEAKER2: "tilbehørsbinding",
};

export const getBindingTypeLabel = (offeringCode?: string | null): string | null => {
    if (!offeringCode) return null;
    const suffix = offeringCode.split(".").pop();
    if (!suffix) return null;
    return BINDING_TYPE_LABELS[suffix] ?? null;
};

export const formatMonthlyPrice = (amount: number): string => `${Math.round(amount)},-/md.`;

export const isPriceplanChanged = (offeringName?: string | null, previousOfferingName?: string | null): boolean => {
    if (!offeringName || !previousOfferingName) return false;
    return offeringName !== previousOfferingName;
};
